// src/pages/Profile/Documents.tsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronRight, FileText } from 'lucide-react';
import { useLegalData } from '../../hooks/useLegalData';
import { LegalDocument } from '../../types';

const Documents: React.FC = () => {
  const navigate = useNavigate();
  // Указываем, что selectedDoc может быть LegalDocument или null
  const [selectedDoc, setSelectedDoc] = useState<LegalDocument | null>(null);
  
  const { docs, loading, error } = useLegalData();

  // === ЭКРАН ПРОСМОТРА ДОКУМЕНТА ===
  if (selectedDoc) {
    return (
      <div className="min-h-screen bg-tg-bg text-tg-text pb-safe animate-fadeIn">
        <div className="px-4 pb-4 pt-tg flex items-center sticky top-0 bg-tg-bg/95 backdrop-blur-md z-10 border-b border-gray-100/5">
          <button onClick={() => setSelectedDoc(null)} className="mr-3 text-tg-text p-1 active:opacity-60">
            <ArrowLeft size={24} />
          </button>
          <h1 className="text-lg font-bold line-clamp-1">{selectedDoc.title}</h1>
        </div>

        <div className="p-5 pb-20">
            <div 
                className="bg-tg-secondary-bg p-5 rounded-2xl shadow-sm text-sm text-tg-text/90"
                dangerouslySetInnerHTML={{ __html: selectedDoc.content }}
            />
            <button 
                onClick={() => setSelectedDoc(null)}
                className="w-full mt-6 bg-tg-button/10 text-tg-button font-bold py-3.5 rounded-xl active:scale-95 transition-transform"
            >
                Закрыть документ
            </button>
        </div>
      </div>
    );
  }

  // === СПИСОК ДОКУМЕНТОВ ===
  return (
    <div className="min-h-screen bg-tg-bg text-tg-text pb-safe">
      <div className="px-4 pb-4 pt-tg flex items-center sticky top-0 bg-tg-bg/95 backdrop-blur-md z-10 border-b border-gray-100/5">
        <button onClick={() => navigate('/profile')} className="mr-3 text-tg-text p-1 active:opacity-60">
          <ArrowLeft size={24} />
        </button>
        <h1 className="text-xl font-bold">Правовые документы</h1>
      </div>

      <div className="p-4 space-y-3">
        {loading && <div className="text-center text-tg-hint p-4">Загрузка документов...</div>}
        {error && <div className="text-center text-red-500 p-4">Ошибка: {error}</div>}
        
        {!loading && !error && docs.map((doc) => (
          <button 
            key={doc.id}
            onClick={() => setSelectedDoc(doc)}
            className="w-full bg-tg-secondary-bg p-4 rounded-2xl flex items-center justify-between active:scale-[0.98] transition-all shadow-sm border border-transparent hover:border-tg-hint/10"
          >
            <div className="flex items-center gap-3">
              <div className="bg-tg-button/10 p-2.5 rounded-xl text-tg-button shrink-0">
                  <FileText size={20} />
              </div>
              <span className="text-sm font-bold text-left leading-tight">{doc.title}</span>
            </div>
            <ChevronRight className="text-tg-hint opacity-50 shrink-0" size={20} />
          </button>
        ))}
      </div>
    </div>
  );
};

export default Documents;
